import { render, staticRenderFns } from "./Trainings.vue?vue&type=template&id=1ee1769c&"
import script from "./Trainings.vue?vue&type=script&lang=js&"
export * from "./Trainings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports